import {Injectable} from '@angular/core';
import {StompService} from '@stomp/ng2-stompjs';
import {Observable} from 'rxjs';

@Injectable()
export class WebsocketService {

  constructor(private stompService: StompService) {
  }

  public listen(UUID: string): Observable<any> {
    return this.stompService.subscribe('/topic/action/' + UUID);
  }
}
